var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, computed } from "mobx";
import { Dashboard } from "./Dashboard";
import { isNotBlank } from "@twii/common/lib/StringUtils";
var DashboardAdd = /** @class */ (function () {
    function DashboardAdd() {
        this.active = false;
        this.makeActive = true;
    }
    DashboardAdd.prototype.init = function (opts) {
        this.dashboardList = opts.dashboardList;
        this.dashboard = new Dashboard();
        this.existing = opts.existing;
        var dashboardNumber = 1;
        var suggestedTitle;
        while (true) {
            suggestedTitle = "Dashboard " + dashboardNumber;
            if (!this.dashboardList.dashboards.some(function (db) { return db.title === suggestedTitle; })) {
                break;
            }
            else {
                dashboardNumber++;
            }
        }
        this.dashboard.setTitle(suggestedTitle);
        this.active = true;
    };
    DashboardAdd.prototype.setExisting = function (existing) {
        this.existing = existing;
    };
    DashboardAdd.prototype.setMakeActive = function (makeActive) {
        this.makeActive = makeActive;
    };
    DashboardAdd.prototype._close = function () {
        this.existing = undefined;
        this.dashboardList = undefined;
        this.active = false;
    };
    Object.defineProperty(DashboardAdd.prototype, "saveEnabled", {
        get: function () {
            return isNotBlank(this.dashboard.title) ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    DashboardAdd.prototype.save = function () {
        if (this.existing) {
            this.dashboard.setComponentConfig(this.existing.componentConfig);
        }
        this.dashboardList.add(this.dashboard, this.makeActive);
        this._close();
    };
    DashboardAdd.prototype.cancel = function () {
        this._close();
    };
    __decorate([
        observable
    ], DashboardAdd.prototype, "active", void 0);
    __decorate([
        observable
    ], DashboardAdd.prototype, "dashboardList", void 0);
    __decorate([
        observable
    ], DashboardAdd.prototype, "existing", void 0);
    __decorate([
        observable
    ], DashboardAdd.prototype, "dashboard", void 0);
    __decorate([
        observable
    ], DashboardAdd.prototype, "makeActive", void 0);
    __decorate([
        action
    ], DashboardAdd.prototype, "init", null);
    __decorate([
        action
    ], DashboardAdd.prototype, "setExisting", null);
    __decorate([
        action
    ], DashboardAdd.prototype, "setMakeActive", null);
    __decorate([
        action
    ], DashboardAdd.prototype, "_close", null);
    __decorate([
        computed
    ], DashboardAdd.prototype, "saveEnabled", null);
    __decorate([
        action
    ], DashboardAdd.prototype, "save", null);
    __decorate([
        action
    ], DashboardAdd.prototype, "cancel", null);
    return DashboardAdd;
}());
export { DashboardAdd };
